module.exports = __webpack_public_path__ + "static/nav_rust1-a7f4a7c068be1817f9f40045ef067c6d.png";